import type { PropsWithChildren } from "react";
import './styles.scss';
interface IMainLayout extends PropsWithChildren<{}> {
}
export default function MainLayout({children} : IMainLayout){
  return (
    <div className="main-layout">
      {children}
    </div>
  )
};